// Toast — single slide-in notification bottom-right, auto-dismiss after 5s.
// Bound to stores.state.toast; legacy CSS (`.toast`, `.toast.show`,
// `.toast-{info,success,error}` in main.css L111-140) drives the appearance.

import { Show, createEffect, onCleanup } from 'solid-js';
import { actions, stores } from '../state/store';

export function Toast() {
  let timer: ReturnType<typeof setTimeout> | null = null;

  createEffect(() => {
    const t = stores.state.toast;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (!t) return;
    timer = setTimeout(() => actions.dismissToast(), t.duration ?? 5000);
  });

  onCleanup(() => {
    if (timer) clearTimeout(timer);
  });

  return (
    <Show when={stores.state.toast}>
      {(t) => (
        <div class={`toast toast-${t().kind} show`} role="status" aria-live="polite">
          {t().message}
        </div>
      )}
    </Show>
  );
}
